import CustomizedPeriodXAxisTick from './CustomizedPeriodXAxisTick';

export default CustomizedPeriodXAxisTick;
